import Page from "../../../modules/Core/Components/Page";
import templateDefault from "../../templates/default/pages/tax";

export default class Home extends Page {
  title = "tax";
  template = templateDefault;
}
